module.exports = __webpack_public_path__ + "670a8afff962e0521162885be859fc05.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/story-background-mobile.jpg
// module id = 407
// module chunks = 1